import { BrowserModule, HAMMER_GESTURE_CONFIG, HammerGestureConfig, HammerModule } from '@angular/platform-browser';
import { Injectable, NgModule } from '@angular/core';
import { DIRECTION_HORIZONTAL } from 'hammerjs';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastModule } from './toast/toast.module';
import { RouteReuseStrategy } from '@angular/router';

import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { CustomRouteReuseStrategy } from '../custom-route-reuse.strategy';
import { TranslationModule } from '../../../common/src/lib/translation/translation.module';
import { BlockerModule } from '../../../common/src/public-api';
import { ButtonModule } from './button/button.module';

@Injectable({
  providedIn: 'root',
})
export class MyHammerConfig extends HammerGestureConfig {
  overrides = <any>{
    swipe: { direction: DIRECTION_HORIZONTAL },
  };
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BlockerModule,
    BrowserAnimationsModule,
    HammerModule,
    FontAwesomeModule,
    ToastModule.forRoot(),
    TranslationModule.forRoot({
      assetFn: (lang) => require(`../assets/i18n/${lang}.json`),
    }),
    ServiceWorkerModule.register('./ngsw-worker.js', { enabled: environment.production }),
    ButtonModule,
  ],
  providers: [
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: MyHammerConfig,
    },
    {
      provide: RouteReuseStrategy,
      useClass: CustomRouteReuseStrategy,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
